import { createStyles, makeStyles } from "@material-ui/core";
import {
    baseColors,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    EnvelopeIcon,
    Input,
    RelodeTheme,
    Text,
    useDeviceSize,
} from "@relode/core";
import * as React from "react";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            infoText: {
                paddingBottom: theme.spacing(2),
                color: theme.palette.grey[500],
            },
            input: {
                margin: theme.spacing(0, 2, 0, 0),
                flex: 1,
            },
            urlShare: {
                display: "flex",
                margin: theme.spacing(2, 0),
            },
            emailShare: {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
            },
            shareActions: {
                display: "flex",
                marginBottom: theme.spacing(2),
            },
            buttonEmail: {
                background: theme.relode.colors.socialShare.email.main,
                border: "1px solid #eee",
                color: baseColors.navy,
                marginBottom: theme.spacing(2),
                "&:hover": {
                    color: baseColors.navy,
                    background: theme.relode.colors.socialShare.email.light,
                },
            },
            buttonCopy: {},
            icon: {
                marginRight: theme.spacing(1),
            },
            [theme.breakpoints.down("sm")]: {
                urlShare: {
                    flexDirection: "column",
                },
                buttonEmail: {
                    width: "100%",
                },
                buttonCopy: {
                    marginTop: theme.spacing(2),
                },
                infoText: {
                    textAlign: "center",
                },
            },
        }),
    { name: "shareCandidateDialog" }
);

interface Props {
    onCancel: () => void;
    shareInfo: {
        name: string;
        emailUrl: string;
        shortenedUrl: string;
    };
}

export const ShareCandidateDialog = (props: Props) => {
    const { onCancel, shareInfo } = props;
    const { name, emailUrl, shortenedUrl } = shareInfo;
    const device = useDeviceSize();

    const classes = useStyles(props);
    const fileInput = React.useRef<HTMLInputElement>();
    const [textCopied, setTextCopied] = React.useState(false);

    const handleCloseDialog = () => {
        setTextCopied(false);
        onCancel();
    };

    const handleCopy = () => {
        fileInput.current && fileInput.current.select();
        document.execCommand("copy");
        handleCopySuccess();
    };

    const handleCopySuccess = () => {
        setTextCopied(true);
    };

    return (
        <Dialog open onClose={handleCloseDialog}>
            <DialogTitle title="share candidate" onClose={handleCloseDialog} />
            <DialogContent>
                <Text variant="h4">{name}</Text>
                <div className={classes.urlShare}>
                    <Input
                        inputRef={fileInput}
                        value={shortenedUrl}
                        className={classes.input}
                        autoFocus={true}
                    />

                    <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        onClick={handleCopy}
                        className={classes.buttonCopy}
                        fullWidth={device === "mobile"}
                    >
                        {textCopied ? "copied" : "copy"}
                    </Button>
                </div>
                <div className={classes.emailShare}>
                    <p className={classes.infoText}>or share via email</p>
                    <Button
                        variant="contained"
                        href={emailUrl}
                        color="default"
                        size="small"
                        fullWidth={device === "mobile"}
                        className={classes.buttonEmail}
                    >
                        <EnvelopeIcon className={classes.icon} /> email
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
